/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * One-shot "instant draft": a single prompt generates a complete themed draft course (course + every lesson) synchronously, using the impactful-training / impactful-presentation method as the engine.
 *
 */
export type GenerateCourseInput = {
    /**
     * One sentence: what to teach or present.
     */
    prompt: string;
    /**
     * train (default) = they can DO it; present = change minds.
     */
    mode?: GenerateCourseInput.mode;
    /**
     * Named theme preset, or 'auto'/empty to let the model pick one.
     */
    theme?: string;
    /**
     * BCP-47 content language (default en).
     */
    language?: string;
    /**
     * Rough size: short ~3 lessons, medium ~5, long ~8.
     */
    length?: GenerateCourseInput.length;
};
export namespace GenerateCourseInput {
    /**
     * train (default) = they can DO it; present = change minds.
     */
    export enum mode {
        TRAIN = 'train',
        PRESENT = 'present',
    }
    /**
     * Rough size: short ~3 lessons, medium ~5, long ~8.
     */
    export enum length {
        SHORT = 'short',
        MEDIUM = 'medium',
        LONG = 'long',
    }
}

